export function roundToPreviousHalf(number) {
    return Math.floor(number * 2) / 2;
  }